import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav4").addClass("active");
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
$(".play").click(function () {
    var video = document.getElementById('myVideo');
    if (video.paused) { //如果已暂停则播放
        $('.play').hide();
        video.play(); //播放控制
    } else { // 已播放点击则暂停
        $('.play').show();
        video.pause(); //暂停控制
    }
})
var pageSwiper = new Swiper(".section3 .swiper-list .mySwiper", {
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
});
var swiperlist = new Swiper(".swiper-content .mySwiper", {
    navigation: {
      nextEl: ".swiper-content .swiper-button-next",
      prevEl: ".swiper-content .swiper-button-prev",
    },
    thumbs: {
        swiper: pageSwiper,
    }
});
$(".section4 ul li").hover(function() {
    $(this).addClass("active").siblings().removeClass("active");
    $(this).removeClass("active1").siblings().addClass("active1");
},function() {
    $(".section4 ul li").removeClass("active");
    $(".section4 ul li").removeClass("active1");
})

// var honorswiper = new Swiper(".section5 .mySwiper", {
//     slidesPerView: 3,
//     slidesPerGroup: 3,
//     spaceBetween: '4%',
//     navigation: {
//         nextEl: ".section5 .swiper-button-next",
//         prevEl: ".section5 .swiper-button-prev",
//     },
//     pagination: {
//       el: ".section5 .swiper-pagination",
//       clickable: true,
//     },
//     breakpoints: { 
//         320: { //当屏幕宽度大于等于320
//             slidesPerView: 2,
//             slidesPerGroup: 2,
//             spaceBetween: 10,
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 3,
//             slidesPerGroup: 3,
//             spaceBetween: '4%',
//         },
//         1280: { //当屏幕宽度大于等于1280
//             slidesPerView: 3,
//             slidesPerGroup: 3,
//             spaceBetween: '4%',
//         }
//     },
// });

var certifySwiper = new Swiper('.section5 .mySwiper', {
	watchSlidesProgress: true,
	slidesPerView: 'auto',
	centeredSlides: true,
	loop: true,
    spaceBetween: '-8%',
    speed:1000,
    autoplay: {
        delay: 2000,
    },
    navigation: {
        nextEl: ".section5 .swiper-button-next",
        prevEl: ".section5 .swiper-button-prev",
    },
    pagination: {
        el: ".section5 .swiper-pagination",
        clickable: true,
    },
})

var workshop = new Swiper(".section6 .swiper-list .swiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    centeredSlides: true,
    slidesPerView: 1.6,
    spaceBetween: '1.5625%',
    loop:true,
    
    navigation: {
        nextEl: ".swiper .swiper-button-next",
        prevEl: ".swiper .swiper-button-prev",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
            slidesPerView: 1,
            spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 1.6,
            spaceBetween: '1.5625%',
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 1.6,
            spaceBetween: '1.5625%',
        }
    },
});

//     observer:true,//修改swiper自己或子元素时，自动初始化swiper
//     observeParents:true,//修改swiper的父元素时，自动初始化swiper
//     centeredSlides: true,
//     slidesPerView: 1.6,
//     spaceBetween: '1.5625%',
//     loop:true,
    
//     navigation: {
//         nextEl: ".workshop-list .swiper-button-next",
//         prevEl: ".workshop-list .swiper-button-prev",
//     },
//     breakpoints: {
//         320: { //当屏幕宽度大于等于320
//             slidesPerView: 1,
//             spaceBetween: 0,
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         },
//         1280: { //当屏幕宽度大于等于1280
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         }
//     },
// });
// var workshop = new Swiper(".swiper-list .swiper3", {
//     observer:true,//修改swiper自己或子元素时，自动初始化swiper
//     observeParents:true,//修改swiper的父元素时，自动初始化swiper
//     centeredSlides: true,
//     slidesPerView: 1.6,
//     spaceBetween: '1.5625%',
//     loop:true,
    
//     navigation: {
//         nextEl: ".workshop-list .swiper-button-next",
//         prevEl: ".workshop-list .swiper-button-prev",
//     },
//     breakpoints: {
//         320: { //当屏幕宽度大于等于320
//             slidesPerView: 1,
//             spaceBetween: 0,
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         },
//         1280: { //当屏幕宽度大于等于1280
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         }
//     },
// });
// var workshop = new Swiper(".swiper-list .swiper4", {
//     observer:true,//修改swiper自己或子元素时，自动初始化swiper
//     observeParents:true,//修改swiper的父元素时，自动初始化swiper
//     centeredSlides: true,
//     slidesPerView: 1.6,
//     spaceBetween: '1.5625%',
//     loop:true,
    
//     navigation: {
//         nextEl: ".workshop-list .swiper-button-next",
//         prevEl: ".workshop-list .swiper-button-prev",
//     },
//     breakpoints: {
//         320: { //当屏幕宽度大于等于320
//             slidesPerView: 1,
//             spaceBetween: 0,
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         },
//         1280: { //当屏幕宽度大于等于1280
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         }
//     },
// });
// var workshop = new Swiper(".swiper-list .swiper5", {
//     observer:true,//修改swiper自己或子元素时，自动初始化swiper
//     observeParents:true,//修改swiper的父元素时，自动初始化swiper
//     centeredSlides: true,
//     slidesPerView: 1.6,
//     spaceBetween: '1.5625%',
//     loop:true,
    
//     navigation: {
//         nextEl: ".workshop-list .swiper-button-next",
//         prevEl: ".workshop-list .swiper-button-prev",
//     },
//     breakpoints: {
//         320: { //当屏幕宽度大于等于320
//             slidesPerView: 1,
//             spaceBetween: 0,
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         },
//         1280: { //当屏幕宽度大于等于1280
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         }
//     },
// });
// var workshop = new Swiper(".swiper-list .swiper6", {
//     observer:true,//修改swiper自己或子元素时，自动初始化swiper
//     observeParents:true,//修改swiper的父元素时，自动初始化swiper
//     centeredSlides: true,
//     slidesPerView: 1.6,
//     spaceBetween: '1.5625%',
//     loop:true,
    
//     navigation: {
//         nextEl: ".workshop-list .swiper-button-next",
//         prevEl: ".workshop-list .swiper-button-prev",
//     },
//     breakpoints: {
//         320: { //当屏幕宽度大于等于320
//             slidesPerView: 1,
//             spaceBetween: 0,
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         },
//         1280: { //当屏幕宽度大于等于1280
//             slidesPerView: 1.6,
//             spaceBetween: '1.5625%',
//         }
//     },
// });
$(".workshop-nav ul li").eq(0).addClass("active");
$(".workshop-list .swiper-list .swiper").eq(0).addClass("active");
$(".workshop-nav ul li").click(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".workshop-list .swiper-list .swiper").eq(index).addClass("active").siblings().removeClass("active");
})